import React from "react";
import { Box } from "@mui/material";
import { GlobalTabCollection, StyledTab } from "../styles";
import WorkRequest from "./Notifications/WorkRequest";
import SDSRequest from "./Notifications/SDSRequest";
import SpecialAnalysis from "./Notifications/SpecialAnalysis";
import NewChemicalAuthorization from "./Notifications/NewChemicalAuthorization";
import ComponentProcurement from "./Notifications/ComponentProcurement";
import SafetyHealthEnvironmental from "./Notifications/SafetyHealthEnvironmental";



  const Notifications = ({ ...props }) => {
    
  const [tabValue, setTabValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const renderTab = () => {
    switch (tabValue) {
      case 0: {
        return <WorkRequest />;
      }
      case 1: {
        return <SDSRequest />;
      }
      case 2: {
        return <SpecialAnalysis />;
      }
      case 3: {
        return <NewChemicalAuthorization />;
      }
      case 4: {
        return <ComponentProcurement />;
      }
      case 5: {
        return <SafetyHealthEnvironmental />;
      }
      default: {
        alert(tabValue);
      }
    }
  };
    return (
        <div>
            <Box sx={{ bgcolor: "#fff", pt: 1, pb: 1 }}>
              <GlobalTabCollection value={tabValue} onChange={handleChange} aria-label="ant example">
                <StyledTab label="Work Request" />
                <StyledTab label="SDS Request" />
                <StyledTab label="Special Analysis" />
                <StyledTab label="New Chemical Authorization" />
                <StyledTab label="Component Procurement" />
                <StyledTab label="Safety Health Environmental" />
              </GlobalTabCollection>
              <Box sx={{ p: 3 }} />
            </Box>
            {renderTab()}
          </div>
      );
    };
  
  export default Notifications;
